import React, { useEffect, useState } from "react";
import InputStyles from "../InputStyles";
// import PropTypes from 'prop-types';
// import IconQuestionCircle from '../../Icons/Basic/IconQuestionCircle';
import { generateRandomString } from "../../../utils/helpers";

const containsNonWhiteSpaceRegex = /.*\S.*/;

const TextInput = ({
  label,
  register,
  formState: { errors = {} } = {},
  fieldName,
  placeholder,
  required,
  helperText,
  setValue,
  errorMessage,
  className = "",
  pattern = {
    value: containsNonWhiteSpaceRegex,
    message: `Please include a non-whitespace character.`,
  },
  type = "text",
  min,
}) => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  const inputRandomId = isClient
    ? `${fieldName}-${generateRandomString()}`
    : null;

  return (
    <InputStyles className={className}>
      <div className="label-container">
        <div>
          <label
            htmlFor={inputRandomId}
            dangerouslySetInnerHTML={{ __html: label }}
          />
          {required && <span className="required-asterisk">*</span>}
        </div>
        <div className="helper-text-container">
          {helperText && <span className="helper-text">{helperText}</span>}
        </div>
      </div>
      <input
        type={type}
        id={inputRandomId}
        className={`${errors[fieldName] ? "error" : ""}`}
        {...register(fieldName, {
          required: required ? errorMessage || `${label} is required` : false,
          pattern,
        })}
        onKeyUp={(e) => {
          if (fieldName === "policy_id_patient") {
            setValue(fieldName, e.target.value.toUpperCase());
          }
        }}
        placeholder={placeholder}
        min={min}
      />
      {errors[fieldName] && (
        <span className="input-error">
          {errors[fieldName].message || errorMessage}
        </span>
      )}
    </InputStyles>
  );
};
export default TextInput;

// TextInput.propTypes = {
//     register: PropTypes.func.isRequired,
//     fieldName: PropTypes.string.isRequired,
//     label: PropTypes.string.isRequired,
//     required: PropTypes.bool,
//     formState: PropTypes.object,
//     placeholder: PropTypes.string,
//     errorMessage: PropTypes.string,
//     helperText: PropTypes.string,
//     setValue: PropTypes.func,
//     tooltipContent: PropTypes.node,
//     pattern: PropTypes.shape({
//         value: PropTypes.instanceOf(RegExp),
//         message: PropTypes.string,
//     }),
// };
